/**
 * Shared constants for cadences-v2.
 * Used across cadence, prospect plan, and bulk message creation/detail pages.
 */

/** Step type badge background colors. */
export const STEP_TYPE_COLORS = {
  email: '#7c3aed',
  task: '#d97706',
  manual: '#6b7280',
  sms: '#16a34a',
  wait: '#6b7280',
  condition: '#0891b2',
};

/** Postmark automated email attachment size limit (7 MB raw). Nylas (manual) allows up to 35 MB. */
export const MAX_AUTOMATED_ATTACHMENT_BYTES = 7_000_000;

/** Selection method options for recipient source (shared across cadence/bulk create). */
export const SELECTION_METHOD_OPTIONS = [
  { label: 'From List', value: 'list' },
  { label: 'From Saved Search', value: 'search' },
  { label: 'Select Contacts', value: 'contacts' },
];

/**
 * Dynamic field placeholders for email editor.
 * Matches the merge fields supported by outreach CompileResource.
 * RTE expects Record<string, string>.
 */
export const DYNAMIC_FIELDS = {
  Prefix: '{{prefix}}',
  'First Name': '{{name_first}}',
  'Last Name': '{{name_last}}',
  Nickname: '{{name_nick}}',
  'Primary Phone': '{{primary_phone}}',
  'Primary Email': '{{primary_email}}',
  'Your Name': '{{user_name}}',
};
